import './Icon_Users.css';
import {ReactComponent as UserIcon} from '../Icons_Audience_Outline_Brand.svg'

function Icon_Users() {
  return (
    
      <div className='users-icon-container'>
         <UserIcon className="users-icon-svg" />
      </div>
            
  );
}

export default Icon_Users;

//<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users-icon lucide-users"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><path d="M16 3.128a4 4 0 0 1 0 7.744"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><circle cx="9" cy="7" r="4"/></svg>
